import { BigNumber } from '@ethersproject/bignumber';
import { Polling } from 'components/common';
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getMixpassSaleStatus } from 'utils/mixpassService';

const useMixpassSaleStatus = () => {
  const [shouldRefetch, setShouldRefetch] = useState<boolean>(true);

  const { data, isLoading, isError } = useQuery(['mixpass-sale-status'], getMixpassSaleStatus, {
    refetchInterval: shouldRefetch ? Polling.slow : false,
  });
  const { price, remainingSupply, publicSaleEnabled, paymentToken = {} } = data || {};

  // stop refetching after sold out
  useEffect(() => {
    if (shouldRefetch && remainingSupply && BigNumber.from(remainingSupply).eq(0)) {
      setShouldRefetch(false);
    }
  }, [shouldRefetch, remainingSupply]);

  return {
    isLoading,
    isError,
    price: price && BigNumber.from(price),
    remainingSupply: remainingSupply && BigNumber.from(remainingSupply),
    publicSaleEnabled: publicSaleEnabled || false,
    paymentToken: {
      ...paymentToken,
      decimals: paymentToken.decimals && parseInt(paymentToken.decimals, 10),
    },
  };
};

export default useMixpassSaleStatus;
